export const zIndex = {
  footer: 10,
  header: 10,
  popover: 20,
  modal: 30,
  progress: 40
}
